import React from "react";
import { Grid, GridRow, Segment } from "semantic-ui-react";

import { IQuestion } from "../../app/types";
import styles from "./Question.module.css";
import { recordAnswer } from "../../app/api";

const AnswerButton = ({
  answerIdx,
  answerText,
  handleClick,
  markCorrect,
  markWrong,
}: {
  answerIdx: number;
  answerText: string;
  handleClick: any;
  markCorrect: boolean;
  markWrong: boolean;
}) => {
  let className = styles.answer;
  if (markCorrect) className += " " + styles.answer__correct;
  if (markWrong) className += " " + styles.answer__wrong;

  return (
    <div className={className} onClick={handleClick}>
      <h1>{answerIdx + 1}</h1> {answerText}
    </div>
  );
};

const Question = ({
  question,
  onAnswer = () => {},
}: {
  question: IQuestion;
  onAnswer?: CallableFunction;
}) => {
  const [selectedAnswer, setSelectedAnswer] = React.useState<number | null>(
    null
  );

  return (
    <Segment>
      <Grid relaxed centered stackable columns={2}>
        {question.image_url && (
          <GridRow columns={1}>
            <Grid.Column textAlign="center">
              <img src={question.image_url} alt="" />
            </Grid.Column>
          </GridRow>
        )}

        <GridRow columns={1}>
          <Grid.Column>
            <h1>
              {question.id}. {question.text}
            </h1>
          </Grid.Column>
        </GridRow>

        <GridRow>
          {question.answers.map((answerText: string, idx: number) => (
            <Grid.Column key={`question_select_answer_${idx}`}>
              <AnswerButton
                answerIdx={idx}
                answerText={answerText}
                handleClick={() => {
                  setSelectedAnswer(idx);
                  recordAnswer(
                    question.id,
                    idx,
                    idx === question.correct_answer
                  );
                  onAnswer();
                }}
                markCorrect={
                  selectedAnswer !== null && idx === question.correct_answer
                }
                markWrong={
                  selectedAnswer === idx &&
                  selectedAnswer !== question.correct_answer
                }
              />
            </Grid.Column>
          ))}
        </GridRow>
      </Grid>
    </Segment>
  );
};

export default Question;
